import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import { Box, Typography } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import { Dai, JoditEditor, RoundedButton } from 'components'
import { Text } from 'views/UserSteps/components'

import helpers from 'helpers'

import useTrailStep from 'hooks/useTrailStep'
import useAuth from 'hooks/useAuth'
import useSnackbar from 'hooks/useSnackbar'
import usePermission from 'hooks/usePermissions'

import * as service from 'service'
import schema from './schema'
import constants from 'constants/index'
import useStyles from './styles'

const TextEditorTrail = () => {
  const snackbar = useSnackbar()
  const { permitted } = usePermission()
  const classes = useStyles()

  const { handleNext, privacyPolicy } = useTrailStep()
  const [loading, setLoading] = useState(false)
  const { company, userCompany } = useAuth()

  const { handleSubmit, control } = useForm({
    mode: 'onSubmit',
    validationSchema: schema,
    defaultValues: {
      title: privacyPolicy?.title ?? 'Aviso de Privacidade',
      content:
        privacyPolicy?.content ??
        helpers.privacyPolicies.defaultPrivacy({
          ...company,
          ...userCompany?.company,
        }),
    },
  })

  const isPermitted = permitted(constants.permissions.PRIVACY_POLICIES.CREATE)

  const onSubmit = async (data) => {
    setLoading(true)

    try {
      const privacyPolicyData = {
        title: 'Aviso de Privacidade',
        status: constants.documents.DRAFT_STATUS_ID,
        content: data.content,
        category: constants.documents.PRIVACY_POLICY_CATEGORY_ID,
        publicDocument: true,
      }
      if (!!privacyPolicy?.id) {
        await service.dponet.privacyPolicies.put({
          privacyPolicyId: privacyPolicy?.id,
          privacyPolicy: privacyPolicyData,
          contentKind: constants.documents.WRITTEN_CONTENT_KIND,
        })
      } else {
        await service.dponet.privacyPolicies.create({
          ...privacyPolicyData,
          createdBySystem: true,
          allowAutomaticEditing: true,
          contentKind: constants.documents.WRITTEN_CONTENT_KIND,
        })
      }
      handleNext()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error.response.data.error) ||
          'Erro ao salvar o aviso de Privacidade',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box width="100%" pb={2}>
      {!isPermitted ? (
        <>
          <Box mb={2}>
            <Alert severity="warning">
              <Typography variant="body1">
                Você não tem permissão para criar ou editar o aviso de
                privacidade.
              </Typography>
            </Alert>
          </Box>
          <Box
            mt={2}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <RoundedButton
              type="button"
              withPadding
              variant="primary"
              onClick={() => handleNext()}
            >
              Avançar
            </RoundedButton>
          </Box>
        </>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box width="100%" pb={2}>
            <Controller
              control={control}
              name="content"
              as={
                <Dai.Card title="Aviso de Privacidade" containerPadding={0}>
                  <Box className={classes.previewBoxContainer}>
                    <Box padding={2} className={classes.previewBox}>
                      <JoditEditor.Preview
                        allowIframe
                        content={
                          privacyPolicy?.content ??
                          helpers.privacyPolicies.defaultPrivacy({
                            ...company,
                            ...userCompany?.company,
                          })
                        }
                      />
                    </Box>
                  </Box>
                </Dai.Card>
              }
              mode="onBlur"
            />
            <Controller
              as={<input type="hidden" value="'Política de Privacidade" />}
              name="title"
              control={control}
            />
          </Box>
          <Text variant="subtitle1" gutterBottom>
            *Para editar este documento, após concluir a jornada, acesse o menu
            “Documentos”
          </Text>
          <Box
            mt={2}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Box mr={2}>
              <RoundedButton
                disabled={loading}
                type="submit"
                withShadow
                withPadding
                variant="primary"
              >
                Salvar Rascunho
              </RoundedButton>
            </Box>
          </Box>
        </form>
      )}
    </Box>
  )
}

export default TextEditorTrail
